import { default as module } from './AbstractModule';
import { $document, isMobile } from '../utils/environment'
import { EVENT as SCROLL_EVENT } from '../scroll/Scroll'

export default class extends module {
    constructor(m) {
        super(m);

        if(isMobile) return

        this.onVisibilityChangeBind = (e) => {
            if(e.target != this.el) return

            requestAnimationFrame(() => {
                if(!this.active && e.way == 'enter') {
                    this.compute()
                    this.initTl()
                    this.active = true
                    this.scrollUpdate()
                } else if(this.active && e.way == 'leave') {
                    this.active = false
                }
            })
        }
        $document.on('visibility.AnimatedSection', this.onVisibilityChangeBind)

        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        this.scrollUpdateBind = this.scrollUpdate.bind(this)
        $document.on(SCROLL_EVENT.SCROLLING, this.scrollUpdateBind)
    }

    init() {
        if(isMobile) return

        this.compute()
    }

    checkResize() {
        if(!this.resizeTick) {
            requestAnimationFrame(() => {
                this.compute();
                this.initTl()
                this.resizeTick = false
            });
            this.resizeTick = true;
        }
    }

    initTl() {
        let progress = 0
        if(this.scrollTl) {
            progress = this.scrollTl.progress()
            this.scrollTl.kill()
        }

        let object = { progress: 0 }
        this.scrollTl = new TimelineMax({ onUpdate: () => {
            console.log(object.progress);
        }})
        this.scrollTl.fromTo(object, 1, { progress: 0 }, { progress: 1 })
        this.scrollTl.pause()
        this.scrollTl.progress(0)
    }

    compute() {
        this.hasSmoothScroll = false
        if(document.documentElement.classList.contains('has-smooth-scroll'))
            this.hasSmoothScroll = true

        // SCROLL RELATED
        this.BCR = this.el.getBoundingClientRect()
        let compensation = this.hasSmoothScroll ? window.app.scroll.y : (document.scrollingElement ? document.scrollingElement.scrollTop : document.documentElement.scrollTop)
        this.offsetTop = this.BCR.top + compensation;
        this.scrollStart = this.offsetTop - window.innerHeight;
        this.scrollEnd = this.scrollStart + window.innerHeight + this.BCR.height
    }

    scrollUpdate() {
        if(!this.active) return

        let progress = (window.app.scroll.y - this.scrollStart) / (this.scrollEnd - this.scrollStart)
        progress = Math.max(0, Math.min(1, Math.round(progress*1000)/1000))

        this.scrollTl.progress(progress)
    }

    destroy() {
        $document.off(SCROLL_EVENT.SCROLLING, this.scrollUpdateBind)
        $document.off('visibility.AnimatedSection', this.onVisibilityChangeBind)
        window.removeEventListener('resize', this.checkResizeBind)
    }
}
